module.exports = __webpack_public_path__ + "static/media/logo.dd4a6a0b.svg";